







































































































import { Component, Watch } from 'vue-property-decorator';
import Mixin from '@/mixin';
import { Table, TableHeader, User } from '@/store/models';
import VPaginationBar from '@/components/items/VPaginationBar.vue';
import VModalCoachItem from '@/components/popup/VModalCoachItem.vue';
import VSearchBar from '@/components/items/VSearchBar.vue';
import coachModule from '@/store/modules/common/coach.module';
import coachService from '@/services/common/coach.service';
import messageModule from '@/store/modules/common/message.module';
import { MessageType } from '@/config/enum';
import VModalImportData from '@/components/popup/VModalImportData.vue';
import VTable from '@/components/items/VTable.vue';
import popupModule from '@/store/modules/common/popup.module';
import popup from '@/data/popup.json';

@Component({
  name: 'Coaches',
  components: {
    VTable,
    VModalImportData,
    VSearchBar,
    VModalCoachItem,
    VPaginationBar
  }
})
export default class Coaches extends Mixin {
  public showModal = false;
  public search = this.$route.query.search_key || '';
  public filter_by = this.$route.query.filter_by || 'all';
  public editUser: User | null = null;
  public showImportModal = false;
  public importUserData = [];
  public filter_options = [{key: 'all', value: 'All'},
  {key: 'one_step', value: 'One Step'},
  {key: 'mcx', value: 'MasterCoachX'},
  {key: 'ok', value: 'OnboardingKit'},
  {key: 'freemium', value: 'Freemium'}]

  get tableData() {
    return {
      headers: [
        {
          name: 'First Name',
          width: 'width--10',
          order: true,
          query: 'coach.firstName'
        } as TableHeader,
        {
          name: 'Last Name',
          width: 'width--10',
          order: true,
          query: 'coach.lastName'
        } as TableHeader,
        {
          name: 'User Id',
          width: 'width--5',
          order: true,
          query: 'id'
        } as TableHeader,
        {
          name: 'Email Address</br>(Username)',
          width: 'width--20',
          order: true,
          query: 'coach.email',
          type: 'email'
        } as TableHeader,
        {
          name: 'Company Name',
          width: 'width--10',
          order: true,
          query: 'coach.companyName'
        } as TableHeader,
        {
          name: 'License</br>Start Date',
          width: 'width--10',
          order: true,
          query: 'subStartDate'
        } as TableHeader,
        {
          name: 'License</br>End Date',
          width: 'width--10',
          order: true,
          query: 'subEndDate'
        } as TableHeader,
        {
          name: 'Status',
          width: 'width--7',
          order: true,
          query: 'accountStatus',
          type: 'status'
        } as TableHeader,
        {
          name: 'Init Password',
          width: 'width--7',
          order: false,
          query: 'initialPassword'
        } as TableHeader,
        {
          name: 'Country',
          width: 'width--7',
          order: false,
          query: 'country'
        } as TableHeader
      ],
      property: {
        edit: true,
        delete: true,
        index: true,
        func: user => this.expired(user),
        overflow_y: true
      },
      values: { data: this.coaches }
    } as Table;
  }

  public doEdit(user: User | null) {
    this.showModal = true;
    if (user === null) {
      this.editUser = {
        initialPassword: this.makeInitPassword(),
        coach: {
          id: null,
          firstName: '',
          lastName: '',
          email: '',
          jobTitle: '',
          department: '',
          companyName: ''
        },
        id: null,
        subEndDate: '',
        subStartDate: '',
        accountStatus: 1,
        country: '',
      };
    } else {
      this.editUser = user;
    }
  }
  public expired(user: User) {
    if (
      user?.licenseExpirationDays &&
      user?.licenseExpirationDays >= 0 &&
      user?.licenseExpirationDays <= 7
    ) {
      return 'expired';
    }
    return '';
  }

  public async doDelete(user: User) {
    await Promise.all([
      popupModule.initPopup(popup.deleteCoach),
      popupModule.setPayload(user),
      popupModule.setShowPopup(true)
    ]);
  }

  get coaches() {
    return coachModule.coaches;
  }

  get paging() {
    return coachModule.paging;
  }

  public async doSearch(event: Event) {
    event.preventDefault();
    await this.$router.push({
      path: this.$route.path,
      query: {
        ...this.$route.query,
        search_key: this.search
      }
    });
  }

  public async doFilter(event: Event) {
    event.preventDefault();
    const queryParams = { ...this.$route.query };
    delete queryParams.offset;
    await this.$router.push({
      path: this.$route.path,
      query: {
        ...queryParams,
        'filter_by': this.filter_by
      }
    });
  }

  public async selectedPage(page) {
    await this.$router.push({
      path: this.$route.path,
      query: {
        ...this.$route.query,
        offset: page
      }
    });
  }

  public openExcel() {
    document.getElementById('excelFileUpload')?.click();
  }

  public async handleFileChange(event: any) {
    const files: FileList = event.target.files;
    const validImageTypes = [
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    ];
    if (files && validImageTypes.includes(files[0].type)) {
      const data = await coachService.import(files[0]);
      if (data['status'] === 'success') {
        this.showImportModal = true;
        this.importUserData = data.data;
      }
    } else {
      await messageModule.showMessage({
        message: 'Please choose image type (.xlsx).',
        type: MessageType.danger
      });
    }
  }

  get query() {
    return this.$route.query;
  }

  @Watch('query', { immediate: true, deep: false })
  public async coachFilter() {
    await coachModule.loadCoaches(this.$route.query);
  }
}
